import { WEB_COMPONENT_PACKAGE_DEPLOYER_FORM } from '../../../webcomponents.constants';
import { PackageDeployerFormWebComponent } from './component/PackageDeployerFormWebComponent';

export { PackageDeployerFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_DEPLOYER_FORM, PackageDeployerFormWebComponent);
